import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchUsers: null,
  refreshUsers: null,
  addUser: ['user'],
  setUsersLoading: ['loading'],
  setCurrentPage: ['currentPage'],
  setUsers: ['usersList'],
  setPagination: ['pagination'],
  changeItemsToDisplay: ['itemsToDisplay'],
  updateList: ['list'],
  loadUserRequest: ['userId'],
  setUserData: ['data'],
  updateHkAvailabilities: ['availabiliies']
});

export const UsersTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  usersList: [],
  pagination: {},
  itemsToDisplay: 100,
  currentPage: 1,
  list: {
    role: [],
    name: [],
    email: [],
    phone: []
  },
  data: {}
};

/* ------- Selectors --------- */
export const UsersSelectors = {
  selectLoading: state => state.users.loading,
  selectUsersList: state => state.users.usersList,
  selectPagination: state => state.users.pagination,
  selectList: state => state.users.list,
  selectUserData: state => state.users.data
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setUsers = (state, { usersList }) => {
  return {
    ...state,
    usersList
  };
};

export const addUser = (state, { user }) => {
  return {
    ...state,
    usersList: [...state.usersList, user]
  };
};

export const setPagination = (state, { pagination }) => {
  return {
    ...state,
    pagination
  };
};

export const setCurrentPage = (state, { currentPage }) => {
  return {
    ...state,
    currentPage
  };
};

export const changeItemsToDisplay = (state, { itemsToDisplay }) => {
  return {
    ...state,
    currentPage: 1,
    itemsToDisplay
  };
};

export const updateList = (state, { list }) => {
  return {
    ...state,
    list: { ...state.list, ...list }
  };
};

export const setUserData = (state, { data }) => {
  return {
    ...state,
    data
  };
};

export const updateHkAvailabilities = (state, { availabiliies }) => {
  return {
    ...state,
    data: {
      ...state.data,
      roleInfo: {
        ...state.data.roleInfo,
        availabiliies
      }
    }
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_USERS_LOADING]: setLoading,
  [Types.SET_USERS]: setUsers,
  [Types.SET_PAGINATION]: setPagination,
  [Types.SET_CURRENT_PAGE]: setCurrentPage,
  [Types.CHANGE_ITEMS_TO_DISPLAY]: changeItemsToDisplay,
  [Types.UPDATE_LIST]: updateList,
  [Types.ADD_USER]: addUser,
  [Types.SET_USER_DATA]: setUserData,
  [Types.UPDATE_HK_AVAILABILITIES]: updateHkAvailabilities
});
